/* eslint-disable no-param-reassign */
import createGettersFactory from '../utils/createGettersFactory';
import createActionsFactory from '../utils/createActionsFactory';
import createMutationsFactory from '../utils/createMutationsFactory';

const namespaced = true;

const stateBase = () => ({
  scaleFactor: 1, // stores the current scale of the canvas
  scaleFactorFit: 1, // stores the scale for "fit to view"
  scaleFactorMode: 0, // 0 - fit to view, 1 - specified zoom
  scaleFactorSelected: 100, // display value for drop up controls
  scaleFactors: [300, 200, 100, 75, 50, 25, 10], // pre-baked scales for selection by user
  panMode: false, // are we panning or selecting
  minZoom: 10,
  maxZoom: 800,
});

const getters = {
// boilerplate getters generated via createGettersFactory and overwrites go here
// convention naming adds get to state prop in camel case 'getStateProp'
};

const actions = {
  // boilerplate actions generated via createActionsFactory and overwrites go here
  // convention naming adds set to state prop in camel case 'setStateProp' and commits
  // a mutation with uppercase snake case 'SET_STATE_PROP'
};
const mutations = {
  // boilerplate mutations generated via createMutationsFactory and overwrites go here
  // convention naming adds SET to state prop in uppercase snake case 'SET_STATE_PROP'
  // and directly assigns state prop to payload
};

export default {
  namespaced,
  state: stateBase,
  getters: { ...createGettersFactory(stateBase()), ...getters },
  actions: { ...createActionsFactory(stateBase()), ...actions },
  mutations: { ...createMutationsFactory(stateBase()), ...mutations },
};
